import { extendZodWithOpenApi } from '@anatine/zod-openapi'
import { z } from 'zod'

import {
  BaseBecoolWebhookEvent,
  BecoolDeliveryCompletedEvent,
  BecoolDeliveryExceptionEvent,
  BecoolDeliveryScheduledEvent,
  BecoolOutForDeliveryEvent,
  BecoolReceivedAtOriginFacilityEvent,
  BecoolWebhookEventType,
} from './becool-webhook-events'

extendZodWithOpenApi(z)

export const BecoolDeliveryCompletedSQSMessage = z.object({
  name: BecoolDeliveryCompletedEvent.shape.type,
  key: BecoolDeliveryCompletedEvent.shape.payload.shape.tracking,
  data: BecoolDeliveryCompletedEvent,
})
export type BecoolDeliveryCompletedSQSMessage = z.infer<typeof BecoolDeliveryCompletedSQSMessage>

export const BecoolDeliveryExceptionSQSMessage = z.object({
  name: BecoolDeliveryExceptionEvent.shape.type,
  key: BecoolDeliveryExceptionEvent.shape.payload.shape.tracking,
  data: BecoolDeliveryExceptionEvent,
})
export type BecoolDeliveryExceptionSQSMessage = z.infer<typeof BecoolDeliveryExceptionSQSMessage>

export const BecoolDeliveryScheduledSQSMessage = z.object({
  name: BecoolDeliveryScheduledEvent.shape.type,
  key: BecoolDeliveryScheduledEvent.shape.payload.shape.tracking,
  data: BecoolDeliveryScheduledEvent,
})
export type BecoolDeliveryScheduledSQSMessage = z.infer<typeof BecoolDeliveryScheduledSQSMessage>

export const BecoolOutForDeliverySQSMessage = z.object({
  name: BecoolOutForDeliveryEvent.shape.type,
  key: BecoolOutForDeliveryEvent.shape.payload.shape.tracking,
  data: BecoolOutForDeliveryEvent,
})
export type BecoolOutForDeliverySQSMessage = z.infer<typeof BecoolOutForDeliverySQSMessage>

export const BecoolReceivedAtOriginFacilitySQSMessage = z.object({
  name: BecoolReceivedAtOriginFacilityEvent.shape.type,
  key: BecoolReceivedAtOriginFacilityEvent.shape.payload.shape.tracking,
  data: BecoolReceivedAtOriginFacilityEvent,
})
export type BecoolReceivedAtOriginFacilitySQSMessage = z.infer<typeof BecoolReceivedAtOriginFacilitySQSMessage>

export const BecoolUnknownEventReceivedSQSMessage = z.object({
  name: z.literal(BecoolWebhookEventType.enum.unknown_event_received),
  key: BaseBecoolWebhookEvent.shape.payload.shape.tracking,
  data: BaseBecoolWebhookEvent,
})
export type BecoolUnknownEventReceivedSQSMessage = z.infer<typeof BecoolUnknownEventReceivedSQSMessage>

export const BecoolEventSQSMessage = z.discriminatedUnion('name', [
  BecoolDeliveryCompletedSQSMessage,
  BecoolDeliveryExceptionSQSMessage,
  BecoolDeliveryScheduledSQSMessage,
  BecoolOutForDeliverySQSMessage,
  BecoolReceivedAtOriginFacilitySQSMessage,
  BecoolUnknownEventReceivedSQSMessage,
])
export type BecoolEventSQSMessage = z.infer<typeof BecoolEventSQSMessage>
